var _path, _rect, _circle, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.547 8.95728C16.0272 12.8469 12.3991 15.5714 8.44357 15.0427C4.48802 14.514 1.70287 10.9323 2.22274 7.04272C2.74262 3.15313 6.37066 0.42859 10.3262 0.957282C14.2818 1.48597 17.0669 5.0677 16.547 8.95728Z",
    fill: "#F8F8F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5967,
    y: 11.9883,
    width: 8.99473,
    height: 4.34545,
    rx: 1,
    transform: "rotate(61.1578 14.5967 11.9883)",
    fill: "#F8F8F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.38223,
    cy: 8.13719,
    r: 5.5347,
    transform: "rotate(7.61295 9.38223 8.13719)",
    fill: "white",
    stroke: "#747272"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.5148,
    y1: 13.5557,
    x2: 16.4714,
    y2: 19.8405,
    stroke: "#747272",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.a0e70885528368e0a3f9dec81d90bd69.svg";
export { ForwardRef as ReactComponent };